export const ZapierLogo = () => {
  return (
    <img src="/zapier-logo_white.png" alt="Zapier" className="h-9 w-auto" />
  );
};
